var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/~/isarray/index.js
// module id = 7
// module chunks = 0 1